/**
 * The corporate-part UOM fields a bulk assignment can write. Values double as the
 * form field names; the paired "edit this field" checkbox is `edit` + the
 * capitalised value, matching QuotePartUpdateBulkForm.
 *
 * Purchase Cost UOM is deliberately absent: the single-part form renders it
 * disabled because it is derived from cost records, and bulk editing must not
 * reach further than editing one part at a time does.
 */
export enum BulkUomField {
  ALTERNATE_SALES_UOM = 'alternateSalesUom',
  ALTERNATE_UOM = 'alternateUom',
  BASE_UOM = 'uom',
  EXTERNAL_UOM = 'externalUom',
  PACKAGE_UOM = 'packageUom',
  SALES_UOM = 'salesUom',
}

/** Display order: base UOM first, then the columns as the audit grid shows them. */
export const BULK_UOM_FIELD_ORDER: BulkUomField[] = [
  BulkUomField.BASE_UOM,
  BulkUomField.SALES_UOM,
  BulkUomField.ALTERNATE_SALES_UOM,
  BulkUomField.PACKAGE_UOM,
  BulkUomField.EXTERNAL_UOM,
  BulkUomField.ALTERNATE_UOM,
];

/**
 * Labels are the part-details UOM form's, so the drawer and the panel name the
 * same column the same way — except ALTERNATE_UOM, which that form calls "SKU
 * UOM". Here it keeps the grid's own "Alternate UOM": this page already shows a
 * separate SKU UOMs column sourced from external products, and borrowing that
 * name for a different field would point the user at the wrong column.
 */
export const BULK_UOM_FIELD_LABEL_KEYS: Record<BulkUomField, string> = {
  [BulkUomField.ALTERNATE_SALES_UOM]: 'labelAlternateSalesUom',
  [BulkUomField.ALTERNATE_UOM]: 'labelAlternateUom',
  [BulkUomField.BASE_UOM]: 'labelBaseUom',
  [BulkUomField.EXTERNAL_UOM]: 'labelExternalErpUom',
  [BulkUomField.PACKAGE_UOM]: 'labelPackageUom',
  [BulkUomField.SALES_UOM]: 'labelSalesUom',
};
